<template>
    <b-card no-body>
        <b-modal hide-footer="true" id="detail" size="lg" :title="'SMS Bildirim İçeriği'" no-close-on-esc no-close-on-backdrop>
            <notification-detail v-model="detail"></notification-detail>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    search
                    pagination="server"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { NotificationApi } from '@/api/notifications'
import NotificationDetail from './components/NotificationDetail.vue'
export default {
    components:{
        BCard,
        NotificationDetail
    },
    data(){
        return{
            detail:{
                Content:null,
                Subject:null
            },
            fields:[
                {name:'Müşteri Kodu',key:'CustomerCode',tdClass:'text-nowrap', sortKey:'NotifyType', sortable:true, thClass:'w-15'},
                {name:'Müşteri Adı',key:'CustomerName',sortable:true, tdClass:'text-nowrap',thClass:'w-20'},
                {name:'Plasiyer',key:'PlasiyerName',sortable:true, thClass:'w-20',tdClass:'text-nowrap',},
                {name:'Cep. Tel',key:'Receipent',sortable:true,thClass:'w-25',tdClass:'text-nowrap',},
                {name:'Mesaj',key:'Content',sortable:true,thClass:'w-10',tdClass:'text-nowrap',},
                {name:'Gönderildi Mi?',key:'IsSent',sortable:true,thClass:'w-10',tdClass:'text-nowrap',},
                {name:'Gönderim Zamanı',key:'SentTime',sortable:false,thClass:'w-10',tdClass:'text-nowrap',},
            ],
            buttons:[
                { text:"Detay",key:"detail",icon:"EyeIcon",variant:"secondary",action:this.getDetail }
            ],
        }
    },
    methods:{
        provider(data){
            return NotificationApi.GetSmsTable(data)
        },
        getDetail(item){
            this.detail.Content = item.Content
            this.detail.Subject = item.MailSubject
            this.$showModal('detail')
        }


    }
}
</script>

<style>

</style>